const config = [
    {
        title: "风格",
        children: ['全部', '时尚', '创意', '简洁', '经典']
    },
    {
        title: "用途",
        children: ['全部', '求职简历', '实习简历', '校招简历', '内推简历']
    },
    {
        title: "行业",
        children: [
            '全部',
            "互联网通信",
            "金融投资",
            "房地产建筑",
            "休闲服务",
            "教育培训",
            "广告传媒",
            "医疗制药",
            "消费运输",
            "制造能源",
            "职能支持",
        ]
    },
    {
        title: "职位",
        children: [
            '全部',
            "后端开发",
            "产品经理",
            "移动开发",
            "测试",
            "证券/基金/期货",
            "教务管理",
            "前端开发",
            "运维/技术支持",
            "数据分析师",
            "项目管理",
            "硬件开发",
            "市场/营销",
            "销售",
            "公关媒介",
            "高端市场职位",
            "会务会展",
            "广告",
            "销售管理",
            "建筑/规划设计",
            "物业管理",
            "地产项目管理",
            "工程管理",
            "翻译",
            "旅游服务",
            "能源/地质",
            "生物制药",
            "护士/护理",
            "运营客服",
            "财务",
            "人力资源",
            "行政",
            "医生/医技",
            "健康整形",
            "医疗器械",
            "酒店经理",
            "高级管理职位",
            "法务",
            "采编/写作/出版",
            "通信",
            "人工智能工程师",
            "投融资",
            "旅游产品开发/策划",
            "影视媒体",
            "教师",
            "视觉/交互设计",
            "用户研究",
            "银行",
            "保险",
            "汽车制造",
            "职业培训",
        ]
    },
]

export const getConfigNameByTypeAndIndex = (type = '风格', index = 0) => {
    return config.find(item => item.title === type).children[index] || '全部'
}

export const getFilterConfigByType = (type = '风格') => {
    return config.find(item => item.title === type).children || []
}

export default config